import packageService from "src/services/packageService";

export const GET_REQUEST = "@package/get-request";
export const GET_SUCCESS = "@package/get-success";
export const GET_FAILURE = "@package/get-failure";

export const GET_ONE_REQUEST = "@package/get_one-request";
export const GET_ONE_SUCCESS = "@package/get_one-success";
export const GET_ONE_FAILURE = "@package/get_one-failure";

export const CREATE_REQUEST = "@package/create-request";
export const CREATE_SUCCESS = "@package/create-success";
export const CREATE_FAILURE = "@package/create-failure";

export const UPDATE_REQUEST = "@package/update-request";
export const UPDATE_SUCCESS = "@package/update-success";
export const UPDATE_FAILURE = "@package/update-failure";

export const UPDATE_IS_PRINTED_REQUEST = "@package/update-is-printed-request";
export const UPDATE_IS_PRINTED_SUCCESS = "@package/update-is-printed-success";
export const UPDATE_IS_PRINTED_FAILURE = "@package/update-is-printed-failure";

export const UPDATE_ACTIVE_REQUEST = "@package/update-active-request";
export const UPDATE_ACTIVE_SUCCESS = "@package/update-active-success";
export const UPDATE_ACTIVE_FAILURE = "@package/update-active-failure";

export const DELETE_REQUEST = "@package/delete-request";
export const DELETE_SUCCESS = "@package/delete-success";
export const DELETE_FAILURE = "@package/delete-failure";

export const GET_RETURN_PACKAGES_REQUEST = "@package/get_return_packages-request";
export const GET_RETURN_PACKAGES_SUCCESS = "@package/get_return_packages-success";
export const GET_RETURN_PACKAGES_FAILURE = "@package/get_return_packages-failure";

export const SEARCH_REQUEST = "@package/search-request";
export const SEARCH_SUCCESS = "@package/search-success";
export const SEARCH_FAILURE = "@package/search-failure";

export const UPDATE_RETURN_PACKAGE_REQUEST = "@package/update-return-package-request";
export const UPDATE_RETURN_PACKAGE_SUCCESS = "@package/update-return-package-success";
export const UPDATE_RETURN_PACKAGE_FAILURE = "@package/update-return-package-failure";

export const UPDATE_RETURN_PACKAGE_LIST_REQUEST =
  "@package/update-return-package-list-request";
export const UPDATE_RETURN_PACKAGE_LIST_SUCCESS =
  "@package/update-return-package-list-success";
export const UPDATE_RETURN_PACKAGE_LIST_FAILURE =
  "@package/update-return-package-list-failure";

export function getList() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_REQUEST});
      const response = await packageService.getList();
      dispatch({
        type: GET_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_FAILURE});
      throw error;
    }
  };
}

export function getOne(data) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_REQUEST});
      const response = await packageService.getOne(data);
      dispatch({
        type: GET_ONE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_FAILURE});
      throw error;
    }
  };
}

export function create(data) {
  return async (dispatch) => {
    try {
      dispatch({type: CREATE_REQUEST});
      const response = await packageService.createUpload(data);
      dispatch({
        type: CREATE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: CREATE_FAILURE});
      throw error;
    }
  };
}

export function update(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_REQUEST});
      const response = await packageService.update(data);
      dispatch({
        type: UPDATE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_FAILURE});
      throw error;
    }
  };
}

export function deletePackage(data) {
  return async (dispatch) => {
    try {
      dispatch({type: DELETE_REQUEST});
      const response = await packageService.deletePackage(data);
      dispatch({
        type: DELETE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: DELETE_FAILURE});
      throw error;
    }
  };
}

export function updatePackageIsPrinted(id) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_IS_PRINTED_REQUEST});
      const response = await packageService.updatePackageIsPrinted(id);
      dispatch({
        type: UPDATE_IS_PRINTED_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_IS_PRINTED_FAILURE});
      throw error;
    }
  };
}

export function getReturnPackageByTradeOrderNumber(tradeOrderNumber) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_RETURN_PACKAGES_REQUEST});
      const response = await packageService.getReturnPackageByTradeOrderNumber(
        tradeOrderNumber
      );
      dispatch({
        type: GET_RETURN_PACKAGES_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_RETURN_PACKAGES_FAILURE});
      throw error;
    }
  };
}

export function searchReturnPackages(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_REQUEST});
      const response = await packageService.searchReturnPackages(data);
      dispatch({
        type: SEARCH_SUCCESS,
        payload: {
          response: response.data,
          total: response.total_items
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_FAILURE});
      throw error;
    }
  };
}

export function updateReturnPackage(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_RETURN_PACKAGE_REQUEST});
      const response = await packageService.updateReturnPackage(data);
      dispatch({
        type: UPDATE_RETURN_PACKAGE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_RETURN_PACKAGE_FAILURE});
      throw error;
    }
  };
}

export function updateReturnPackageList(data = []) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_RETURN_PACKAGE_LIST_REQUEST});
      const response = await packageService.updateReturnPackageList(data);
      dispatch({
        type: UPDATE_RETURN_PACKAGE_LIST_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_RETURN_PACKAGE_LIST_FAILURE});
      throw error;
    }
  };
}
